export type WalletProviderMode = "external" | "internal";

/** External wallet UI and postMessage bridge follow customer config only. */
export function resolveWalletProviderMode(
  walletMode?: "external" | "internal",
): WalletProviderMode {
  return walletMode === "external" ? "external" : "internal";
}
